<aside
  class="relative m-4 flex h-sidebar shrink-0 flex-col rounded-lg bg-white shadow-sm transition-[width] duration-300 ease-sidebar"
  [class.w-sidebar-collapsed]="isCollapsed"
  [class.w-sidebar-open]="!isCollapsed"
>
  <!-- Logo zone -->
  <div
    class="mb-4 flex items-center px-6 pb-2 pt-6"
    [class.justify-center]="isCollapsed"
    [class.justify-start]="!isCollapsed"
  >
    @if (!isCollapsed) {
      <!-- Full Greentripper logo with slogan (expanded state) -->
      <a
        routerLink="/home/travel-board"
        class="group relative ml-[22px] flex cursor-pointer items-center"
        aria-label="Greentripper"
      >
        <img
          src="/assets/Logo___Greentripper_white_horizontal_with_slogan.svg"
          alt="Greentripper - Act for Travel"
          class="h-9 w-auto transition-opacity duration-300 ease-out [filter:brightness(0)_invert(58%)_sepia(5%)_hue-rotate(80deg)] group-hover:opacity-0"
        />
        <img
          src="/assets/Logo___Greentripper_primary_horizontal_with_slogan.svg"
          alt="Greentripper - Act for Travel"
          class="absolute left-0 top-0 h-9 w-auto opacity-0 transition-opacity duration-300 ease-out group-hover:opacity-100"
        />
      </a>
    } @else {
      <!-- Icon logo (collapsed state) -->
      <a
        routerLink="/home/travel-board"
        class="group relative ml-[8px] flex h-12 w-12 cursor-pointer items-center justify-center"
        [pTooltip]="'Greentripper - Act for Travel'"
        tooltipPosition="right"
        aria-label="Greentripper"
      >
        <img
          src="/assets/Logo___Greentripper_icon_white.svg"
          alt="Greentripper"
          class="h-12 w-12 transition-opacity duration-300 ease-out [filter:brightness(0)_invert(58%)_sepia(5%)_hue-rotate(80deg)] group-hover:opacity-0"
        />
        <img
          src="/assets/Logo___Greentripper_icon_primary.svg"
          alt="Greentripper"
          class="absolute inset-0 h-12 w-12 opacity-0 transition-opacity duration-300 ease-out group-hover:opacity-100"
        />
      </a>
    }
  </div>

  <!-- Company Context Selector (Super Admin only) -->
  <div
    class="mb-4 transition-all duration-300 ease-sidebar"
    [class.px-6]="!isCollapsed"
    [class.flex]="isCollapsed"
    [class.justify-center]="isCollapsed"
  >
    <app-company-context-selector
      [isCollapsed]="isCollapsed"
      (expandRequest)="onToggle()"
    ></app-company-context-selector>
  </div>

  <!-- Navigation Menu -->
  <nav
    class="scrollbar-thin scrollbar-thumb-greyscale-300 hover:scrollbar-thumb-greyscale-400 flex min-h-0 flex-1 flex-col justify-between gap-2 overflow-y-auto overflow-x-hidden px-6 transition-all duration-300 ease-sidebar"
    [class.items-center]="isCollapsed"
  >
    <div
      class="flex flex-col gap-1 transition-all duration-300 ease-sidebar"
      [class.items-center]="isCollapsed"
    >
      @for (item of menuItems(); track item.route) {
        <app-sidebar-item
          [item]="item"
          [isCollapsed]="isCollapsed"
        ></app-sidebar-item>
      }
    </div>

    <div class="mb-2 mt-auto">
      <!-- Discovery Indicator Component -->
      <app-discovery-indicator [isCollapsed]="isCollapsed">
      </app-discovery-indicator>

      <div
        class="flex flex-col gap-1 transition-all duration-300 ease-sidebar"
        [class.items-center]="isCollapsed"
      >
        @for (item of secondaryItems(); track item.route) {
          <!-- Render the actual menu item -->
          <app-sidebar-item
            [item]="item"
            [isCollapsed]="isCollapsed"
          ></app-sidebar-item>
        }

        <!-- Render toggle button at the end after all items -->
        <button
          class="relative flex overflow-hidden rounded-lg border-0 bg-transparent text-greyscale-900 no-underline transition-all duration-300 ease-sidebar hover:bg-primary-50 hover:text-primary-600 [&:hover>div]:text-primary-600"
          [class]="
            isCollapsed
              ? 'h-12 w-12 items-center justify-center gap-0 px-3 py-3'
              : 'h-12 items-center gap-4 px-6 py-3'
          "
          [pTooltip]="isCollapsed ? ('navigation.expandMenu' | transloco) : ''"
          tooltipPosition="right"
          (click)="onToggle()"
          pRipple
        >
          <!-- Icon -->
          <div
            class="flex shrink-0 items-center justify-center text-greyscale-500 transition-colors duration-300 ease-out"
          >
            <lucide-icon
              [name]="isCollapsed ? 'chevrons-right' : 'chevrons-left'"
              [size]="24"
              class="h-6 w-6"
            >
            </lucide-icon>
          </div>

          <!-- Label -->
          <span
            class="whitespace-nowrap font-source-sans text-base font-normal leading-6 transition-all duration-300 ease-out"
            [class]="isCollapsed ? 'invisible w-0 opacity-0' : ''"
          >
            {{
              isCollapsed
                ? ("navigation.expandMenu" | transloco)
                : ("navigation.collapseMenu" | transloco)
            }}
          </span>
        </button>
      </div>
    </div>
  </nav>

  <!-- Footer with user info -->
  <app-sidebar-footer
    class="flex-shrink-0"
    [isCollapsed]="isCollapsed"
  ></app-sidebar-footer>
</aside>
